import React from 'react';
import logo from '../logo-white-x1024.png';
import { Link } from 'react-router-dom';
import Icon from './icon/icon';

const socialLinks = [
	{
		name: 'Spotify',
		url: 'https://open.spotify.com/artist/3na2KF7Hmo35K6BSrheLt3',
		icon: 'spotify',
	},
	{
		name: 'Instagram',
		url: 'https://www.instagram.com/djaconitum/',
		icon: 'instagram',
	},
	{
		name: 'YouTube',
		url: 'https://youtube.com/@djaconitum',
		icon: 'youtube',
	},
	{
		name: 'Patreon',
		url: 'https://patreon.com/djaconitum',
		icon: 'patreon',
	},
	{
		name: 'TikTok',
		url: 'https://tiktok.com/@djaconitum',
		icon: 'tiktok',
	},
	{
		name: 'SoundCloud',
		url: 'https://soundcloud.com/djaconitum',
		icon: 'soundcloud',
	},
	{
		name: 'X',
		url: 'https://twitter.com/djaconitum',
		icon: 'twitter',
	},
	{
		name: 'Twitch',
		url: 'https://www.twitch.tv/djaconitum',
		icon: 'twitch',
	},
	{
		name: 'Apple Music',
		url: 'https://music.apple.com/us/artist/aconitum/1816189853',
		icon: 'website',
	},
	{
		name: 'Email',
		url: 'mailto:contact@djaconitum.com',
		icon: 'website',
	},
	{
		name: 'Gravatar',
		url: 'https://gravatar.com/djaconitum',
		icon: 'website',
	},
	{
		name: 'Facebook',
		url: 'https://www.facebook.com/djaconitum',
		icon: 'facebook',
	},
];

const footerLinks = [
	{
		name: 'Home',
		url: '/',
		extern: false,
	},
	{
		name: 'Contact',
		url: '/contact/',
		extern: false,
	},
	{
		name: 'Privacy Policy',
		url: '/privacy-policy/',
		extern: false,
	},
	{
		name: 'Cookie Policy',
		url: '/cookies/',
		extern: false,
	},
];

export default function Footer() {
	return (
		<footer className="aconitum-footer">
			<div className="aconitum-container">
				<div className="aconifooter__content">
					<div className="aconitum-footer__social">
						<ul>
							{socialLinks.map(({ name, url, icon }) => (
								<li key={name}>
									<a href={url} target="_blank" rel="noreferrer">
										<Icon name={icon} />
										<label>{name}</label>
									</a>
								</li>
							))}
						</ul>
					</div>

					<Link to="/" className="footer-logo-link">
						<img
							src={logo}
							alt="DJ Aconitum"
							className="footer-logo"
						/>
					</Link>

					<div className="aconitum-footer__menu">
						<div className="menu-footer-menu-container">
							<ul id="menu-footer-menu" className="menu">
								{footerLinks.map((link, i) => (
									<li key={i}>
										{link.extern ? (
											<a href={link.url}>{link.name}</a>
										) : (
											// <a href={link.url}>{link.name}</a>
											<Link to={link.url}>
												{link.name}
											</Link>
										)}
									</li>
								))}
							</ul>
						</div>
					</div>

					<p className="copyright-note">
						© 2026 DJ Aconitum. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
}
